import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'emotion-theming';
import { theme } from 'styled';
import Router from 'Router';
import { PersistGate } from 'redux-persist/integration/react';
import persistedStore, { history } from 'redux/store';

const { store, persistor } = persistedStore;
ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <PersistGate loading={null} persistor={persistor}>
        <Router history={history} /> {/* pass history object as props */}
      </PersistGate>
    </ThemeProvider>
  </Provider>,
  // eslint-disable-next-line no-undef
  document.getElementById('root'),
);
